import { useStoreSelector } from 'hooks/store'
import ItsmeView from 'features/registration/steps/itsme-view/ItsmeView'
import PersonalData from './PersonalData'
import { StepProps } from '../types'
import { FlowAlternatives } from 'store/customer/enums'

const PersonalDataWrapper = (props: StepProps) => {
  // Redux store
  const { itsme, flowAlternative } = useStoreSelector((store) => store.customer)

  // Constants
  // If there is no prefilled object, the identify call has not been fired yet, or has been reset due to going to the previous step
  const stillHasToIdentify = !itsme?.prefilled

  return stillHasToIdentify && flowAlternative[FlowAlternatives.ITSME] ? <ItsmeView /> : <PersonalData {...props} />
}

export default PersonalDataWrapper
